import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { KnowledgeItemsWidgetComponent } from './knowledge-items-widget.component';
import { getItemById } from 'shared/store/selectors/knowledge.selector';

const mapStateToProps = ({ knowledge, application }, ownProps) => {
  const { location } = ownProps;
  const { id: itemId } = location?.state || {};
  let knowledgeItem = null;

  if (!!itemId) {
    knowledgeItem = getItemById(knowledge, { id: itemId });
  }

  return {
    adminMode: application.adminMode,
    knowledgeItem,
  };
};

const ConnectedKnowledgeItemsWidget = connect(mapStateToProps)(KnowledgeItemsWidgetComponent);

export const KnowledgeItemsWidget = props => {
  const location = useLocation();
  return <ConnectedKnowledgeItemsWidget {...props} location={location} />;
};
